import { DashboardLayout } from "components/DashboardLayout";
import Async from "components/DesignSystem/AsyncComponents/Async";
import Breadcrumb from "components/DesignSystem/Breadcrumb/Breadcrumb";
import { CURRENT_SEASON } from "constants/vendor";
import { useGetVendorDetailQuery } from "store/apis/vendors";
import { VendorBillsAndTxn } from "./VendorBillsAndTxn";
import { VendorDeatilAccordion } from "./VendorDeatilAccordion";
import { DocumentPreviewModal } from "components/PreviewModal";

export const VendorDetail = ({
  breadcrumb,
  entityId,
  groupId,
  vendorId,
}: {
  breadcrumb: { link?: string; name: string }[];
  entityId: string;
  groupId: string;
  vendorId: string;
}) => {
  const { data, isLoading, isSuccess, isError } = useGetVendorDetailQuery(
    {
      entityId,
      vendorId,
      season: CURRENT_SEASON,
    },
    {
      skip: !vendorId || !entityId,
    }
  );

  const pagebreadcrumb = [...breadcrumb, { name: data?.name || "Vendor" }];

  return (
    <DashboardLayout
      header={
        <Breadcrumb.Root>
          {pagebreadcrumb.map((item, index) => (
            <Breadcrumb.Item key={index} link={item.link}>
              {item.name}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb.Root>
      }
    >
      <Async.Root
        isLoading={isLoading}
        isSuccess={isSuccess}
        isError={isError}
        isEmpty={!data}
      >
        <Async.ErrorHandler>
          <div className="t-text-red t-h-1/2 t-flex t-justify-center t-items-center">
            Something went wrong
          </div>
        </Async.ErrorHandler>
        <Async.Empty>
          <></>
        </Async.Empty>
        <Async.Success>
          {data && (
            <div className="t-relative t-mt-4 sm:t-mt-6">
              <title>{`${data.name} | Inkle`}</title>
              <VendorDeatilAccordion
                vendor={data}
                entityId={entityId}
                groupId={groupId}
              />
              <VendorBillsAndTxn
                entityId={entityId}
                groupId={groupId}
                vendor={data}
                vendorId={vendorId}
              />
            </div>
          )}
        </Async.Success>
      </Async.Root>
      <DocumentPreviewModal />
    </DashboardLayout>
  );
};
